import React, { forwardRef, useState } from 'react';

import type { BoxProps } from '@chakra-ui/react';
import { Button, Flex, Text } from '@chakra-ui/react';

interface Props extends BoxProps {
  children: React.ReactNode;
  noOfLines: number;
  withoutShowLess?: boolean;
}

export const ExpandableText = forwardRef<HTMLDivElement, Props>(
  ({ children, noOfLines, withoutShowLess = false, ...rest }, ref) => {
    const [expandedCount, setExpandedCount] = useState<number | undefined>(
      noOfLines
    );
    const [isClicked, setIsClicked] = useState(false);
    const handleToggle = () => {
      setIsClicked(true);
      setExpandedCount(expandedCount ? undefined : noOfLines);
    };

    const inputRef = React.useRef<HTMLInputElement>(null);

    const isTextClamped =
      (inputRef.current?.scrollHeight as number) >
        (inputRef.current?.clientHeight as number) || isClicked;

    const shouldShowButton =
      isTextClamped && (!withoutShowLess || expandedCount !== undefined);

    return (
      <Flex position="relative" ref={ref} {...rest}>
        <Flex ref={inputRef} noOfLines={expandedCount}>
          {children}
        </Flex>
        <Flex backgroundColor="white" position="absolute" bottom={0} right={0}>
          <Text px={1}>{!expandedCount ? '' : '... '}</Text>
          <Button
            display={shouldShowButton ? 'block' : 'none'}
            size="sm"
            variant="link"
            onClick={handleToggle}
            color="primary.500"
          >
            <Text>{!expandedCount ? 'Show less' : 'Read more'}</Text>
          </Button>
        </Flex>
      </Flex>
    );
  }
);

ExpandableText.displayName = 'ExpandableText';
